import { render } from "./DeLoading.vue?vue&type=template&id=a6c38af2"
import script from "./DeLoading.vue?vue&type=script&lang=js"
export * from "./DeLoading.vue?vue&type=script&lang=js"

import "./DeLoading.vue?vue&type=style&index=0&id=a6c38af2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__